import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38aef318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert alert-primary text-center" }
const _hoisted_2 = { class: "container mb-1" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Search and Replace Rules:"),
  /*#__PURE__*/_createElementVNode("div", { class: "fst-italic" }, [
    /*#__PURE__*/_createTextVNode("Rules are applied top to bottom, and search text is "),
    /*#__PURE__*/_createElementVNode("u", null, "not"),
    /*#__PURE__*/_createTextVNode(" case sensitive.")
  ])
], -1))
const _hoisted_5 = { class: "col-4 text-end" }
const _hoisted_6 = { class: "field-rules-container p-1 mb-1" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "input-group mb-2 input-group-row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-grip-vertical" })
], -1))
const _hoisted_10 = { class: "ms-1 span-padding" }
const _hoisted_11 = { class: "ms-1 p-1" }
const _hoisted_12 = ["onChange"]
const _hoisted_13 = ["selected"]
const _hoisted_14 = ["selected"]
const _hoisted_15 = ["selected"]
const _hoisted_16 = ["selected"]
const _hoisted_17 = { class: "ms-2" }
const _hoisted_18 = ["value", "onKeyup", "disabled"]
const _hoisted_19 = { class: "ms-1 p-1" }
const _hoisted_20 = ["disabled", "onChange"]
const _hoisted_21 = ["selected", "disabled"]
const _hoisted_22 = ["selected"]
const _hoisted_23 = ["selected"]
const _hoisted_24 = ["selected"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 span-padding" }, "with", -1))
const _hoisted_26 = { class: "ms-2" }
const _hoisted_27 = ["value", "onKeyup"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 span-padding" }, "On Form Types", -1))
const _hoisted_29 = { class: "ms-1 p-1 me-auto" }
const _hoisted_30 = ["onChange"]
const _hoisted_31 = ["selected"]
const _hoisted_32 = ["selected"]
const _hoisted_33 = ["selected"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "p-3 text-center"
}
const _hoisted_38 = { class: "container" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "fw-bold" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fst-italic" }, "This is how your data will appear based on your preferred casing, the rules settings above, and your current form.", -1))
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col" }
const _hoisted_45 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "banner", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewRule && _ctx.addNewRule(...args)))
            }, "Add New Rule")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (this.list.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_draggable, _mergeProps({
                modelValue: this.list,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.list) = $event)),
                handle: ".drag-handle"
              }, _ctx.dragOptions, { onChange: _ctx.onDrop }), {
                default: _withCtx(() => [
                  _createVNode(_TransitionGroup, {
                    type: "transition",
                    name: "flip-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.list, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", { key: idx }, [
                          (item.ruleStatus !== 'deleted')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _hoisted_9,
                                _createElementVNode("span", _hoisted_10, _toDisplayString(item.priorityOrder + 1) + ". If Field", 1),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("select", {
                                    class: "form-select d-inline-block select-match-value",
                                    onChange: ($event: any) => (_ctx.onTextMatchCriteriaChange(idx, $event.target.value))
                                  }, [
                                    _createElementVNode("option", {
                                      value: "1",
                                      selected: _ctx.isSelected(1, item.textMatchOption)
                                    }, "Contains", 8, _hoisted_13),
                                    _createElementVNode("option", {
                                      value: "2",
                                      selected: _ctx.isSelected(2, item.textMatchOption)
                                    }, "Equals", 8, _hoisted_14),
                                    _createElementVNode("option", {
                                      value: "3",
                                      selected: _ctx.isSelected(3, item.textMatchOption)
                                    }, "Is Blank", 8, _hoisted_15),
                                    _createElementVNode("option", {
                                      value: "4",
                                      selected: _ctx.isSelected(4, item.textMatchOption)
                                    }, "Doesn't Contain", 8, _hoisted_16)
                                  ], 40, _hoisted_12),
                                  _createElementVNode("span", _hoisted_17, [
                                    _createElementVNode("input", {
                                      type: "text",
                                      value: item.textMatchCriteria,
                                      onKeyup: ($event: any) => (_ctx.onTextMatchCriteriaKeyup(idx, $event)),
                                      disabled: this.isMatchValueDisabled(item.textMatchOption, idx)
                                    }, null, 40, _hoisted_18)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("select", {
                                    class: "form-select d-inline-block select-edit-value",
                                    disabled: this.isEditValueDisabled(item.textMatchOption),
                                    onChange: ($event: any) => (_ctx.onTextEditValueChange(idx, $event.target.value))
                                  }, [
                                    _createElementVNode("option", {
                                      value: "2",
                                      selected: _ctx.isSelected(2, item.textEditOption),
                                      disabled: this.isEditValueOptionDisabled(item.textMatchOption)
                                    }, "Replace Matching Text", 8, _hoisted_21),
                                    _createElementVNode("option", {
                                      value: "1",
                                      selected: _ctx.isSelected(1, item.textEditOption)
                                    }, "Replace Entire Text", 8, _hoisted_22),
                                    _createElementVNode("option", {
                                      value: "4",
                                      selected: _ctx.isSelected(4, item.textEditOption)
                                    }, "Append at the End", 8, _hoisted_23),
                                    _createElementVNode("option", {
                                      value: "3",
                                      selected: _ctx.isSelected(3, item.textEditOption)
                                    }, "Prepend", 8, _hoisted_24)
                                  ], 40, _hoisted_20),
                                  _hoisted_25,
                                  _createElementVNode("span", _hoisted_26, [
                                    _createElementVNode("input", {
                                      type: "text",
                                      value: item.textEditValue,
                                      onKeyup: ($event: any) => (_ctx.onTextEditValueKeyup(idx, $event))
                                    }, null, 40, _hoisted_27)
                                  ])
                                ]),
                                _hoisted_28,
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("select", {
                                    class: "form-select d-inline-block select-run-rules-on-value",
                                    onChange: ($event: any) => (_ctx.onRunRulesOnChange(idx, $event.target.value))
                                  }, [
                                    _createElementVNode("option", {
                                      value: "0",
                                      selected: _ctx.isSelected(0, item.runRulesOn)
                                    }, "All", 8, _hoisted_31),
                                    _createElementVNode("option", {
                                      value: "1",
                                      selected: _ctx.isSelected(1, item.runRulesOn)
                                    }, "UAD", 8, _hoisted_32),
                                    _createElementVNode("option", {
                                      value: "2",
                                      selected: _ctx.isSelected(2, item.runRulesOn)
                                    }, "Non UAD", 8, _hoisted_33)
                                  ], 40, _hoisted_30)
                                ]),
                                _createElementVNode("span", {
                                  class: "input-group-text hover",
                                  onClick: ($event: any) => (_ctx.deleteConfirmation(idx))
                                }, _hoisted_36, 8, _hoisted_34)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16, ["modelValue", "onChange"])
            ]))
          : _createCommentVNode("", true),
        (this.list.length === 0 || _ctx.checkActiveRules())
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, "To setup custom Search and Replace Rules, click Add New Rule."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.friendlyFieldName) + " Result: ", 1),
              _createElementVNode("span", null, "(Original Value: " + _toDisplayString(_ctx.originalValue?.trim() || 'No Value') + ")", 1)
            ]),
            _hoisted_42
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("input", {
              type: "text",
              class: "w-100",
              readonly: "",
              value: this.rulesPreviewText
            }, null, 8, _hoisted_45)
          ])
        ])
      ])
    ]),
    (_ctx.modalConformation.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalConformation.component), {
          key: 0,
          message: _ctx.modalConformation.message,
          buttons: _ctx.modalConformation.buttons,
          modalSize: _ctx.modalConformation.size,
          onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalConformation.show = false))
        }, null, 8, ["message", "buttons", "modalSize"]))
      : _createCommentVNode("", true)
  ], 64))
}